import React from "react";

import { faPencil } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ICellRendererParams } from "ag-grid-community";

import { BusinessModalSection } from "constants/navigation";

import { openEditBusinessModal } from "lib/navigation";

import { ClickableColumn } from "./columnStyles";

interface VendorRelationshipsRow {
  vendor_id?: string;
  vendor?: Pick<Business, "id">;
  vendorRelationships?: string;
}

export function VendorRelationshipsRenderer({
  data,
}: ICellRendererParams<VendorRelationshipsRow>) {
  if (!data) {
    return null;
  }

  const { vendorRelationships } = data;
  const vendorId = data.vendor_id || data.vendor?.id;
  const onClickEdit = vendorId
    ? () => {
        openEditBusinessModal(
          vendorId,
          "",
          BusinessModalSection.BUSINESS_RELATIONSHIPS,
        );
      }
    : null;
  return (
    <ClickableColumn onClick={onClickEdit}>
      {vendorRelationships}
      <FontAwesomeIcon icon={faPencil} />
    </ClickableColumn>
  );
}
